import { ApiError } from '../../types/ApiError';
import { ApiResponse } from '../../types/ApiResponse';
import { ValidationText } from '../types/dtos/VarderingarModel';

export interface ServerValidationError<T = unknown> {
  field: keyof T;
  errorType: ValidationText;
  value?: string;
  text?: string;
}

// Example of assumed format of errorResponse.data.message:
// "The following validation errors occured: [{BIAREA-MAX_VALUE-3200}, {ANTAL_VANINGAR-MUST_BE_POSITIVE}]"
export const validationErrorParser = <T>(
  errorResponse: ApiResponse<ApiError>
): ServerValidationError<T>[] => {
  const errorsString = errorResponse.data.message.replace(/.*: \[(.*)\]/, '$1');
  const errors = errorsString.split(',');
  return errors.map((e): ServerValidationError<T> => {
    const errorParts = e.replace(/{(.*)}/, '$1').split('-');
    const serverValidationError: ServerValidationError<T> = {
      field: errorParts[0].trim() as keyof T,
      errorType: errorParts[1] as ValidationText,
      value: errorParts[2],
    };
    serverValidationError.text = `${errorTypeToText(
      serverValidationError.errorType
    )}${serverValidationError.value ? `: ${serverValidationError.value}` : ''}`;
    return serverValidationError;
  });
};

export const isCustomValidationError = (
  apiError: ApiResponse<ApiError>
): boolean =>
  apiError.data.message.includes('The following validation errors occured:');

const errorTypeToText = (errorType: ValidationText): string =>
  ({
    [ValidationText.MAX_VALUE]: 'Maxvärde',
    [ValidationText.MIN_VALUE]: 'Minvärde',
    [ValidationText.MUST_BE_POSITIVE]: 'Måste ha positivt värde',
    [ValidationText.MUST_BE_POSITIVE_OR_ZERO]:
      'Måste ha positivt värde eller 0',
    [ValidationText.NOT_NULL]: 'Måste anges',
    [ValidationText.WRONG_FORMAT]: 'Felaktigt format',
  }[errorType]);
